const DEFAULT_BRAND = 'default';

const isDefaultBrand = (brand?: string) => {
  if(!brand) return true
  return brand?.toLowerCase() === DEFAULT_BRAND;
}

export { DEFAULT_BRAND, isDefaultBrand };
